export enum Overlay {
  ALIGNBELOW = 'Align below',
  ALIGNABOVE = 'Align above',
}

export enum Align {
  START = 'start',
  END = 'end',
}
